import session from '../../config/session';
import React, { useState, useContext } from 'react';
import { AuthContext, AuthProvider } from '../context/AuthContext';

const Navigation = () => {
  const { user } = useContext(AuthContext);

  return (
    <nav className="pcoded-navbar  ">
      <div className="navbar-wrapper  ">
        <div className="navbar-content scroll-div ">
          {/* SEZIONE PROFILO UTENTE */}
          <div>
            <div className="main-menu-header">
              <img className="img-radius" src={session.AVATAR} alt="User-Profile-Image" />
              <div className="user-details">
                <span>{user}</span>
                <div id="more-details">{session.ROLE}<i className="fa fa-chevron-down m-l-5" /></div>
              </div>
            </div>
            <div className="collapse" id="nav-user-link">
              <ul className="list-unstyled">
                <li className="list-group-item"><a href="#!"><i className="feather icon-user m-r-5" />View Profile</a></li>
                <li className="list-group-item"><a href="#!"><i className="feather icon-settings m-r-5" />Settings</a></li>
                <li className="list-group-item"><a href="/logout"><i className="feather icon-log-out m-r-5" />Logout</a></li>
              </ul>
            </div>
          </div>
          {/* LINK ALLE PAGINE */}
          <ul className="nav pcoded-inner-navbar ">
            <li className="nav-item pcoded-menu-caption">
              <label>Navigation</label>
            </li>
            <li className="nav-item">
              <a href="/" className="nav-link"><span className="pcoded-micon"><span className="material-symbols-outlined">home</span></span><span className="pcoded-mtext">Dashboard</span></a>
            </li>
            <li className="nav-item">
              <a href="/orders" className="nav-link"><span className="pcoded-micon"><span className="material-symbols-outlined">receipt</span></span><span className="pcoded-mtext">Orders</span></a>
            </li>
            <li className="nav-item">
              <a href="/portfolios" className="nav-link"><span className="pcoded-micon"><span className="material-symbols-outlined">account_balance_wallet</span></span><span className="pcoded-mtext">Portfolios</span></a>
            </li>
            <li className="nav-item">
              <a href="/certificates" className="nav-link"><span className="pcoded-micon"><span className="material-symbols-outlined">shield</span></span><span className="pcoded-mtext">Certificates</span></a>
            </li>
            <li className="nav-item">
              <a href="/vpn" className="nav-link"><span className="pcoded-micon"><span className="material-symbols-outlined">vpn_key</span></span><span className="pcoded-mtext">VPN Test</span></a>
            </li>
            <li className="nav-item">
              <a href="/mailbox" className="nav-link"><span className="pcoded-micon"><span className="material-symbols-outlined">email</span></span><span className="pcoded-mtext">Mailbox</span></a>
            </li>
            <li className="nav-item">
              <a href="/filemanager" className="nav-link"><span className="pcoded-micon"><span className="material-symbols-outlined">folder</span></span><span className="pcoded-mtext">Filemanager</span></a>
            </li>
            <li className="nav-item">
              <a href="/scanner" className="nav-link"><span className="pcoded-micon"><span className="material-symbols-outlined">scanner</span></span><span className="pcoded-mtext">Scanner</span></a>
            </li>
          </ul>
          {/* CARD CON LINK AD ALTRI ELEMENTI GRAFICI DEL TEMPLATE */}
          <div className="card text-center">
            <div className="card-block">
              <button type="button" className="close" data-dismiss="alert" aria-hidden="true">×</button>
              <img src="/images/lab.png" height={50} />
              <h6 className="mt-3">dixxip Lab</h6>
              <p>Experiment with new technologies and services in our laboratory</p>
              <a href="https://lab.dixxip.com/" target="_blank" className="btn btn-primary btn-sm text-white m-0">Enter!</a>
              
            </div>
          </div>
        </div>
      </div>
    </nav>
    
  );
}
export default Navigation;